var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon404 = function SvgIcon404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383.06,
    height: 222.29,
    viewBox: "0 0 383.06 222.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustra",
    transform: "translate(-201.196 -358.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1991",
    "data-name": "Grupo 1991",
    transform: "translate(230.049 416.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3887",
    "data-name": "Caminho 3887",
    d: "M686.371,1356.685q-24.309,0-39.628-16.122t-15.32-43.131q0-25.828,14.644-42.667t40.641-16.839q24.055,0,39.206,15.868t15.151,42.372q0,27.433-15.277,43.975T686.371,1356.685Zm-.169-26.166q8.946,0,12.872-7.807T703,1294.14q0-30.047-16.121-30.048-17.389,0-17.388,34.269Q669.49,1330.519,686.2,1330.519Z",
    transform: "translate(-631.423 -1237.926)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3888",
    "data-name": "Caminho 3888",
    d: "M1794.995,1327.32v41.865h-35.873V1253.972h49.208q18.4,0,27.98,4.22a34.021,34.021,0,0,1,15.193,12.914,35.182,35.182,0,0,1,5.613,19.5q0,16.459-11.479,26.588T1815,1327.32Zm-.507-24.731H1806.3q15.614,0,15.615-11.479,0-10.8-14.433-10.8h-13Z",
    transform: "translate(-1634.54 -1252.199)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3889",
    "data-name": "Caminho 3889",
    d: "M2657.615,1321.572l32.833-5.909q4.135,13.927,21.27,13.927,13.336,0,13.336-7.09a6.582,6.582,0,0,0-3.081-5.782q-3.082-2.067-11.016-3.667-30.307-5.808-38.912-15.18a31.514,31.514,0,0,1-8.607-22.036,34.488,34.488,0,0,1,12.365-27.1q12.364-10.807,35.577-10.808,35.2,0,46.507,28.276l-29.289,8.863q-4.557-11.563-18.484-11.564-11.565,0-11.563,7.175a5.674,5.674,0,0,0,2.616,4.98q2.615,1.773,10.13,3.371,20.682,4.374,29.378,7.738a31.678,31.678,0,0,1,14.515,11.515,32.2,32.2,0,0,1,5.82,19.216q0,17.484-14.18,28.338t-37.223,10.853Q2667.489,1356.685,2657.615,1321.572Z",
    transform: "translate(-2433.771 -1237.926)",
    fill: "#1f35b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1992",
    "data-name": "Grupo 1992",
    transform: "translate(285.644 471.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3890",
    "data-name": "Caminho 3890",
    d: "M1665.69,1852.525h-5.126v-9.806h3.132Z",
    transform: "translate(-1634.465 -1831.441)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3891",
    "data-name": "Caminho 3891",
    d: "M1650.854,1755.478c.866,4.025.226,8.084-2.2,8.964-2.279.826-6.235-1.358-8.044-5.337-1.9-4.189-.975-7.32,2.4-8.486C1646.591,1749.38,1649.9,1751.066,1650.854,1755.478Z",
    transform: "translate(-1615.844 -1749.164)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3892",
    "data-name": "Caminho 3892",
    d: "M1631.67,1740.664c-3.727.291-5.788,3.67-5.55,7.012.223,3.12,3.559,4.787,3.559,4.787s1.1-3.167,2.9-3.672c2.516-.7,1.428-2.953,2.6-3.2,1.225-.253,3.889-1.226,3.845-3.008C1637.307,1742.646,1635.857,1740.336,1631.67,1740.664Z",
    transform: "translate(-1603.81 -1740.632)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3893",
    "data-name": "Caminho 3893",
    d: "M1662.369,1813.618a1.133,1.133,0,1,1-1.564-.764A1.241,1.241,0,0,1,1662.369,1813.618Z",
    transform: "translate(-1634.139 -1804.801)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3894",
    "data-name": "Caminho 3894",
    d: "M1676.506,1813.92s.281,4.35,1.112,6c.724,1.439,3.882,2.925,5.6-.49,0,0-1.741.363-1.544-.374.232-.868,2.024-.878,2.024-.878a.446.446,0,0,0,.413-.339,3.4,3.4,0,0,0-.14-1.254,15.808,15.808,0,0,1-3.393.846c-1.158,0-2.21-.817-3.19-3.515Z",
    transform: "translate(-1648.645 -1805.823)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3895",
    "data-name": "Caminho 3895",
    d: "M1639.155,2224.958l-4.711-26.354-3.2-12.986-3.223-13.012-1.1-4.424-9.241,2.948,1.671,4.24,4.869,12.353c1.619,4.124,3.264,8.246,4.865,12.385l7.915,25.375.33,1.058,2.015-.492Z",
    transform: "translate(-1596.323 -2120.948)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3896",
    "data-name": "Caminho 3896",
    d: "M1473.4,2169.162l-.368,4.542-2.085,25.733-19.459,9.12-1,.471.734,1.917,1.062-.322,22.313-6.744a2.452,2.452,0,0,0,1.685-1.832l.079-.371,5.675-26.656.949-4.457Z",
    transform: "translate(-1447.589 -2121.821)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3897",
    "data-name": "Caminho 3897",
    d: "M1605.413,2143.736l17.275,3.355,5.4,51.63-5.794.795Z",
    transform: "translate(-1585.406 -2099.203)",
    fill: "#f48603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3898",
    "data-name": "Caminho 3898",
    d: "M1507.484,2155.311l17.428-2.435s-2.672,32.323-7.886,36.446c-2.9,2.293-19.018,6.153-19.018,6.153l-1.735-4.948s12.134-4.912,13.149-6.431C1510.526,2182.444,1507.484,2155.311,1507.484,2155.311Z",
    transform: "translate(-1488.324 -2107.333)",
    fill: "#ff9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3899",
    "data-name": "Caminho 3899",
    d: "M1670.894,1933.279l11.423,16.325-2.078-.58,13.472-5.114,1.224-.465.972,2.343-1.193.538-13.136,5.925a1.68,1.68,0,0,1-2.021-.506l-.057-.074-12.147-15.794-1.339-1.741,3.62-2.657Z",
    transform: "translate(-1639.313 -1910.396)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3900",
    "data-name": "Caminho 3900",
    d: "M1655.424,1940.912c1.679,4.4,9.595,14.171,15.711,15.946,3.632,1.054,11.506-4.47,11.506-4.47l-1.147-3.545s-5.969,3.966-9.178.919-8.895-12.8-11.79-13.342C1657.975,1935.943,1654.669,1938.936,1655.424,1940.912Z",
    transform: "translate(-1629.795 -1914.745)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3901",
    "data-name": "Caminho 3901",
    d: "M1604.474,1912.726s2.689,2.358,5.378.786c0,0,.92,9.823,2.123,13.831s4.741,14.538,4.741,14.538h-19.548C1596.645,1932.913,1600.034,1922.726,1604.474,1912.726Z",
    transform: "translate(-1578.025 -1893.714)",
    fill: "#dbc6af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3902",
    "data-name": "Caminho 3902",
    d: "M1593.346,1905.431s-9.343,13.973-7.441,28.878c0,0-.8,2.928,9.8,2.529s11.208-1.863,11.208-1.863a102.19,102.19,0,0,1-7.258-27.952S1595.69,1907.169,1593.346,1905.431Z",
    transform: "translate(-1567.826 -1887.225)",
    fill: "#22cbd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3903",
    "data-name": "Caminho 3903",
    d: "M1592.571,1935.272c-1.33,2.3-2.62,4.7-3.805,7.091-.591,1.2-1.159,2.41-1.677,3.624a31.411,31.411,0,0,0-1.328,3.623c-.083.3-.152.58-.214.87l-.18.958c-.108.651-.211,1.3-.3,1.969-.18,1.325-.331,2.667-.466,4.013-.262,2.692-.47,5.412-.626,8.113l-.076,1.306-2.541-.064v-1.308c0-2.762.055-5.5.166-8.262.059-1.38.135-2.762.244-4.154.053-.7.123-1.4.2-2.1l.138-1.066c.059-.382.133-.768.215-1.134a34.707,34.707,0,0,1,1.274-4.145c.487-1.327,1.016-2.622,1.566-3.9,1.109-2.566,2.284-5.049,3.565-7.552l1-1.956,3.944,2.177Z",
    transform: "translate(-1564.009 -1910.142)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3904",
    "data-name": "Caminho 3904",
    d: "M1581.072,1923.422c-3.37,3.29-5.309,10.76-6.743,16.965s-.269,15.629-.269,15.629l3.864.17s.221-9.591,1.741-13.745,8.213-13.25,7.557-16.122C1586.646,1923.789,1582.586,1921.945,1581.072,1923.422Z",
    transform: "translate(-1557.121 -1902.76)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3905",
    "data-name": "Caminho 3905",
    d: "M1929.891,2028.1c.3.849-.726,2.378-2.611,3.293-1.737.843-3.3.4-3.654-.441C1922.834,2029.08,1929.431,2026.784,1929.891,2028.1Z",
    transform: "translate(-1868.406 -1995.995)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3906",
    "data-name": "Caminho 3906",
    d: "M1599.723,2253.83c.376-.123.554-1.192.254-2.522-.277-1.226-.925-1.924-1.316-1.835C1597.79,2249.668,1599.142,2254.021,1599.723,2253.83Z",
    transform: "translate(-1579.147 -2193.252)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3907",
    "data-name": "Caminho 3907",
    d: "M1794.169,2687.53s-1.332-.352-1.7-.485c-1.473-.53-5.288-2.093-5.288-2.093a2.287,2.287,0,0,1-1.648.9,3.1,3.1,0,0,1-1.532-.206c-.377-.011-.7.6-.724,1.357a2.509,2.509,0,0,0,.07.688l-.032,1.056,11.244.338.032-1.07A.48.48,0,0,0,1794.169,2687.53Z",
    transform: "translate(-1743.619 -2580.628)",
    fill: "#0a3c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3908",
    "data-name": "Caminho 3908",
    d: "M1428.65,2532.585s-.052-1.377-.032-1.769c.077-1.564.461-5.668.461-5.668a2.29,2.29,0,0,1-1.346-1.313,3.1,3.1,0,0,1-.25-1.525c-.1-.365-.775-.5-1.509-.3a2.486,2.486,0,0,0-.637.267l-1.02.278,2.954,10.854,1.033-.281A.479.479,0,0,0,1428.65,2532.585Z",
    transform: "translate(-1424.317 -2435.608)",
    fill: "#0a3c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3909",
    "data-name": "Caminho 3909",
    d: "M1929.4,2021.146c-.262-.3-1.314-.034-2.415.77-1.015.742-1.4,1.614-1.161,1.937C1926.354,2024.575,1929.81,2021.6,1929.4,2021.146Z",
    transform: "translate(-1870.363 -1990.051)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3910",
    "data-name": "Caminho 3910",
    d: "M1577.4,2250.235c-.9-.065-1.894-1.611-1.984-3.7-.084-1.928.948-3.182,1.857-3.175C1579.3,2243.373,1578.788,2250.334,1577.4,2250.235Z",
    transform: "translate(-1558.719 -2187.819)",
    fill: "#f4caab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1995",
    "data-name": "Grupo 1995",
    transform: "translate(175.91 495.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1993",
    "data-name": "Grupo 1993",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_13",
    "data-name": "Subtra\\xE7\\xE3o 13",
    d: "M16266.337,24347.094c-.184,0-.367,0-.551,0v-3.863l.716,0a103.785,103.785,0,0,0,40.917-8.207c11.627-4.861,21.522-11.176,31.092-17.281,7.441-4.748,14.471-9.234,21.662-12.527,7.9-3.629,14.92-5.32,22.084-5.32.236,0,.475,0,.708.006a30.2,30.2,0,0,1,11.045,2.457,48.089,48.089,0,0,1,9.268,5.207,59.535,59.535,0,0,1,9.141,7.941l0,0-2.879,2.6a57.75,57.75,0,0,0-8.432-7.3,44.715,44.715,0,0,0-8.4-4.779,26.386,26.386,0,0,0-9.809-2.248c-.221-.006-.444-.006-.66-.006-14.625,0-27.141,7.98-41.631,17.223l-.007,0-.011.008c-11.554,7.377-24.648,15.738-40.761,20.916a107.33,107.33,0,0,1-16.394,3.877A112.766,112.766,0,0,1,16266.337,24347.094Z",
    transform: "translate(-16239.999 -24299.895)",
    fill: "gray",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1994",
    "data-name": "Grupo 1994",
    transform: "translate(167.196 11.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3912",
    "data-name": "Caminho 3912",
    d: "M1960.031,2050.437a2.136,2.136,0,0,0-3,.35l-3.065,3.874a2.135,2.135,0,0,0,.349,3l2.194,1.735,5.715-7.223Z",
    transform: "translate(-1953.506 -2049.042)",
    fill: "#a6b8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3913",
    "data-name": "Caminho 3913",
    d: "M2056.567,2094.849l-4.107-3.25a1.1,1.1,0,0,0-1.544.18l-15.023,18.986a1.1,1.1,0,0,0,.18,1.544l4.106,3.249a1.1,1.1,0,0,0,1.544-.18l15.023-18.986A1.1,1.1,0,0,0,2056.567,2094.849Z",
    transform: "translate(-2026.58 -2085.856)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3914",
    "data-name": "Caminho 3914",
    d: "M1979.684,2043.293a8.227,8.227,0,0,0-11.556,1.347l-4.665,5.9a8.227,8.227,0,0,0,1.347,11.556l5.361,4.242,14.875-18.8Z",
    transform: "translate(-1960.783 -2041.518)",
    fill: "#ff9500"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1996",
    "data-name": "Grupo 1996",
    transform: "translate(425.46 480.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3915",
    "data-name": "Caminho 3915",
    d: "M3406.993,2132.976c-.364.082-1.027-.7-1.427-1.924-.369-1.129-.181-2.01.178-2.127C3406.547,2128.663,3407.557,2132.85,3406.993,2132.976Z",
    transform: "translate(-3360.326 -2078.748)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3916",
    "data-name": "Caminho 3916",
    d: "M3183.684,1676.165c3.948-2.829,8.7-.9,9.332,3.185.82,5.3-.216,9.572,1.1,13.089a26.472,26.472,0,0,1,1.477,10.81c-5.387-7.343-10.954-4.3-14.028-11.68C3180.579,1689.2,3179.9,1678.875,3183.684,1676.165Z",
    transform: "translate(-3160.564 -1674.824)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3917",
    "data-name": "Caminho 3917",
    d: "M3221.176,1776.042h4.713v-9.016h-2.88Z",
    transform: "translate(-3196.485 -1756.84)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3918",
    "data-name": "Caminho 3918",
    d: "M3186.953,1686.808c-.8,3.7-.208,7.433,2.026,8.242,2.1.759,5.733-1.249,7.4-4.908,1.751-3.852.9-6.731-2.207-7.8C3190.873,1681.2,3187.826,1682.751,3186.953,1686.808Z",
    transform: "translate(-3165.742 -1681.186)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3919",
    "data-name": "Caminho 3919",
    d: "M3131.963,2138.905l3.168-22.944,3.341-22.918.6-4.147,8.729,1.884-1.159,4.027-6.4,22.24-6.292,22.273-.277.982-1.854-.388Z",
    transform: "translate(-3117.003 -2043.152)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3920",
    "data-name": "Caminho 3920",
    d: "M3235.128,2088.891l.146,4.188.846,24.352,10.638,15.861.569.847-1.474,1.163-.692-.75-13.592-14.715a1.9,1.9,0,0,1-.482-.984l-.058-.352-4.077-24.592-.686-4.134Z",
    transform: "translate(-3201.013 -2043.147)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3921",
    "data-name": "Caminho 3921",
    d: "M3149.481,2081.9h-12.362l-5.333,43.02,7.193,1.047Z",
    transform: "translate(-3116.969 -2036.928)",
    fill: "#f48603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3922",
    "data-name": "Caminho 3922",
    d: "M3227.044,2081.9h-11.878s2.176,27.5,3.948,30.729c2.124,3.875,10.536,12.868,10.536,12.868l5.713-4.413s-6.017-8.519-7.471-12.519S3227.044,2081.9,3227.044,2081.9Z",
    transform: "translate(-3191.139 -2036.927)",
    fill: "#ff9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3923",
    "data-name": "Caminho 3923",
    d: "M3068.208,1863.247c-.9,2.35-1.91,4.732-2.979,7.03-.539,1.15-1.1,2.288-1.69,3.39a28.762,28.762,0,0,1-1.9,3.125,22.241,22.241,0,0,1-2.426,2.671c-.9.879-1.843,1.742-2.8,2.589-1.921,1.69-3.914,3.344-5.922,4.932l-.97.767,1.424,1.934,1.012-.71c2.154-1.511,4.25-3.057,6.323-4.678,1.034-.812,2.058-1.647,3.066-2.522q.757-.654,1.5-1.362c.248-.248.488-.469.741-.741s.495-.554.721-.833a31.78,31.78,0,0,0,2.325-3.4c.7-1.149,1.341-2.312,1.963-3.482,1.24-2.349,2.376-4.7,3.463-7.139l.844-1.9-3.941-1.607Z",
    transform: "translate(-3043.788 -1840.708)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3924",
    "data-name": "Caminho 3924",
    d: "M3101.364,1877.364l4.53,6.323s5.818-6.706,8.738-10.953c3.67-5.339,8.771-13.692,4.547-16.384-5.521-3.518-8.623,11.826-10.729,14.669C3106.748,1873.317,3101.364,1877.364,3101.364,1877.364Z",
    transform: "translate(-3089.909 -1835.833)",
    fill: "#22cbd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3925",
    "data-name": "Caminho 3925",
    d: "M3174.868,1841.7s-2.542,2.228-5.083.743c0,0-.869,9.283-2.007,13.071s-4.088,13.42-4.088,13.42l18.082.319C3182.266,1860.781,3179.065,1851.154,3174.868,1841.7Z",
    transform: "translate(-3145.349 -1823.268)",
    fill: "#76d3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3926",
    "data-name": "Caminho 3926",
    d: "M3235.042,1866.516c1.9,1.638,3.8,3.377,5.6,5.147.9.888,1.783,1.791,2.622,2.714a29.589,29.589,0,0,1,2.311,2.821c.167.24.316.47.461.71l.458.8c.3.547.594,1.1.88,1.664.573,1.127,1.124,2.278,1.663,3.437,1.07,2.321,2.1,4.685,3.078,7.047l.473,1.142,2.248-.846-.407-1.168c-.86-2.464-1.758-4.894-2.714-7.323-.481-1.213-.979-2.423-1.508-3.631-.264-.6-.544-1.208-.831-1.812l-.454-.909c-.172-.323-.357-.644-.545-.945a32.814,32.814,0,0,0-2.424-3.3c-.847-1.033-1.721-2.025-2.61-3-1.787-1.945-3.607-3.8-5.528-5.633l-1.5-1.435-2.845,3.168Z",
    transform: "translate(-3207.42 -1841.315)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3927",
    "data-name": "Caminho 3927",
    d: "M3167.408,1831.913s8.829,13.205,7.032,27.291c0,0,.758,2.767-9.26,2.39s-10.593-1.761-10.593-1.761a96.576,96.576,0,0,0,6.86-26.415S3165.192,1833.555,3167.408,1831.913Z",
    transform: "translate(-3137.252 -1814.559)",
    fill: "#22cbd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3928",
    "data-name": "Caminho 3928",
    d: "M3242.32,1884.324l7.546-1.886s-3.443-8.079-6.32-12.356c-3.615-5.376-9.507-13.192-13.563-10.254-5.3,3.84,7.825,12.367,9.694,15.372C3241.188,1877.627,3242.32,1884.324,3242.32,1884.324Z",
    transform: "translate(-3203.205 -1838.819)",
    fill: "#22cbd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3929",
    "data-name": "Caminho 3929",
    d: "M3412.767,2124.155c.7-.487.763-2.214-.167-3.941-.858-1.592-2.3-2.1-3.031-1.655C3407.931,2119.555,3411.689,2124.908,3412.767,2124.155Z",
    transform: "translate(-3363.703 -2069.4)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3930",
    "data-name": "Caminho 3930",
    d: "M2997.729,2109.045c.483.7,2.549.566,4.76-.651,2.039-1.123,2.862-2.748,2.434-3.493C3003.968,2103.237,2996.983,2107.962,2997.729,2109.045Z",
    transform: "translate(-2997.674 -2057.075)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3931",
    "data-name": "Caminho 3931",
    d: "M3017.288,2101.612c-.077-.366.712-1.018,1.941-1.4,1.134-.354,2.011-.156,2.124.2C3021.607,2101.218,3017.408,2102.177,3017.288,2101.612Z",
    transform: "translate(-3015.116 -2053.048)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3932",
    "data-name": "Caminho 3932",
    d: "M3064.229,2542.937l1.458-.26h0l5.331-2.064v.042a1.266,1.266,0,0,0,1.172,1.086,2.434,2.434,0,0,0,1.567-.214.253.253,0,0,1,.121-.076c.356,0,.645.582.645,1.3a2.381,2.381,0,0,1-.086.647v1h-10.62v-1.01A.452.452,0,0,1,3064.229,2542.937Z",
    transform: "translate(-3056.51 -2444.966)",
    fill: "#0a3c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3933",
    "data-name": "Caminho 3933",
    d: "M3361.526,2498.54l.9-1.174h0l2.553-5.115.029.032a1.266,1.266,0,0,0,1.6.014,2.437,2.437,0,0,0,1.015-1.214.254.254,0,0,1,.038-.137c.263-.24.868,0,1.353.528a2.371,2.371,0,0,1,.372.536l.672.738-7.853,7.149-.68-.747A.452.452,0,0,1,3361.526,2498.54Z",
    transform: "translate(-3321.223 -2400.702)",
    fill: "#0a3c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3934",
    "data-name": "Caminho 3934",
    d: "M3202.391,1676.137a5.283,5.283,0,0,1,2.719.569c1.468.76,3.4,2.577,3.788,6.693.358,3.838-1.179,5.716,2.1,9.336,3.689,2.8,10.261,2.322,9.5,8.607s-9.093,5.464-11.074,2.322-1.758-5.943-2.86-7.923-3.014-.82-3.971-3.005c-1.122-2.056.826-6.668,1.176-7.463a2.432,2.432,0,0,0-1.791-1.964c-2.689-.734-4.918-3.279-4.918-4.1S3199.523,1676.137,3202.391,1676.137Z",
    transform: "translate(-3175.036 -1675.992)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3935",
    "data-name": "Caminho 3935",
    d: "M3245.08,1740.267a1.042,1.042,0,1,0,1.438-.7A1.141,1.141,0,0,0,3245.08,1740.267Z",
    transform: "translate(-3217.635 -1732.344)",
    fill: "#f4caab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1999",
    "data-name": "Grupo 1999",
    transform: "translate(401.554 515.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2051",
    "data-name": "Grupo 2051",
    transform: "translate(173.697 56.078) rotate(-169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3911",
    "data-name": "Caminho 3911",
    d: "M466.412,1987.028a136.484,136.484,0,0,1-26.335-2.693l.748-3.809c47.373,9.3,74.144-7.78,97.764-22.849,7.446-4.751,14.478-9.238,21.659-12.529,8.167-3.744,15.408-5.429,22.795-5.311,15.459.252,28.9,14.98,29.46,15.607l-2.884,2.6c-.127-.141-12.883-14.1-26.639-14.324-.218,0-.438-.005-.655-.005-14.631,0-27.166,8-41.648,17.237-11.565,7.379-24.673,15.742-40.765,20.913A108.492,108.492,0,0,1,466.412,1987.028Z",
    transform: "translate(-440.077 -1939.831)",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3980",
    "data-name": "Caminho 3980",
    d: "M1960.031,2050.437a2.136,2.136,0,0,0-3,.35l-3.065,3.874a2.135,2.135,0,0,0,.349,3l2.194,1.735,5.715-7.223Z",
    transform: "translate(1979.776 2075.429) rotate(180)",
    fill: "#a6b8cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1998",
    "data-name": "Grupo 1998",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 0.726, -11.032)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1109",
    "data-name": "Ret\\xE2ngulo 1109",
    width: 4.531,
    height: 17.967,
    rx: 2.266,
    transform: "translate(0 18.772) rotate(-82.538)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1110",
    "data-name": "Ret\\xE2ngulo 1110",
    width: 4.531,
    height: 17.967,
    rx: 2.266,
    transform: "translate(1.293 8.904) rotate(-82.538)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3937",
    "data-name": "Caminho 3937",
    d: "M2798.118,1987l-5.192-.68a1.1,1.1,0,0,0-1.233.947l-3.144,24.005a1.1,1.1,0,0,0,.947,1.232l5.193.68a1.1,1.1,0,0,0,1.232-.947l3.144-24.006A1.1,1.1,0,0,0,2798.118,1987Z",
    transform: "translate(-2778.738 -1986.315)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3938",
    "data-name": "Caminho 3938",
    d: "M2865.387,2005.675l-6.778-.888-3.113,23.768,6.778.888a8.227,8.227,0,0,0,9.226-7.088l.977-7.455A8.227,8.227,0,0,0,2865.387,2005.675Z",
    transform: "translate(-2838.297 -2002.746)",
    fill: "#ff9500"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2002",
    "data-name": "Grupo 2002",
    transform: "translate(363.757 358.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2000",
    "data-name": "Grupo 2000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3939",
    "data-name": "Caminho 3939",
    d: "M1932.975,848.184l-4.5-1.238,2.368-8.609,2.75.756Z",
    transform: "translate(-1918.892 -824.19)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3940",
    "data-name": "Caminho 3940",
    d: "M1950.88,768.64c-.212,3.743-1.754,7.151-4.1,7.338-2.2.174-5.146-2.7-5.774-6.628-.661-4.138.912-6.662,4.156-6.87C1948.609,762.257,1951.111,764.538,1950.88,768.64Z",
    transform: "translate(-1929.907 -756.698)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3941",
    "data-name": "Caminho 3941",
    d: "M1927.078,762.141a3.907,3.907,0,0,1,3.243-1.844c1.086-.122,2.847.362,3.062-.421s-.23-3.685-4.671-4.441a6.392,6.392,0,0,0-7.538,4.451c-.877,2.521.6,5.417,2.61,5.027S1926.2,763.794,1927.078,762.141Z",
    transform: "translate(-1912.168 -750.335)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_34",
    "data-name": "Elipse 34",
    cx: 1.015,
    cy: 1.217,
    rx: 1.015,
    ry: 1.217,
    transform: "translate(12.518 12.096) rotate(-8.252)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3942",
    "data-name": "Caminho 3942",
    d: "M1926.574,711.542a4.135,4.135,0,0,1-7.706,3c-.667-1.714.9-2.794,3.027-3.622S1925.908,709.827,1926.574,711.542Z",
    transform: "translate(-1910.208 -710.271)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3943",
    "data-name": "Caminho 3943",
    d: "M2118.321,1106.538c-.041.818-1.314,1.758-3.055,1.885-1.605.117-2.666-.8-2.674-1.622C2112.573,1104.953,2118.383,1105.272,2118.321,1106.538Z",
    transform: "translate(-2082.669 -1061.839)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3944",
    "data-name": "Caminho 3944",
    d: "M1951.013,1155.636l-.324-.06-23.193-4.29-4.081-.755-1.016,8.786,4.146.2,20.12.952-8.143,19.564-.387.932,1.7.833.5-.877,12.348-21.695a2.475,2.475,0,0,0,.277-.758A2.426,2.426,0,0,0,1951.013,1155.636Z",
    transform: "translate(-1913.488 -1101.893)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3945",
    "data-name": "Caminho 3945",
    d: "M1950.8,1163.093l-.294-.054-25.731-4.737-4.08-.751-1.06,8.724,4.141.248,24.009,1.438,1.317,24.784.054,1.008,1.9.006.06-1.007,1.625-27.179A2.376,2.376,0,0,0,1950.8,1163.093Z",
    transform: "translate(-1911.032 -1108.137)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3946",
    "data-name": "Caminho 3946",
    d: "M1894.578,1138.822c2.941,4.741,20.422,3.1,22.94,6.581,3.36,4.643-10.447,22.587-10.447,22.587l-4.595-2.566s7.039-12.692,6.756-13.6c-.36-1.156-19.545,1.584-24.736-2.8-4.031-3.4-2.04-10.2-2.04-10.2Z",
    transform: "translate(-1877.519 -1091.478)",
    fill: "#ff9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3947",
    "data-name": "Caminho 3947",
    d: "M1891.035,1138.822c2.565,5.824,23.417,3.672,26.375,8.749,2.385,4.1-.064,24.889-.064,24.889l-5.517-.15s.03-17.7-1.05-18.9c-.794-.884-22.931,1.157-28.456-2.8-4.729-3.384-2.04-11.788-2.04-11.788Z",
    transform: "translate(-1875.347 -1091.478)",
    fill: "#f48603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3948",
    "data-name": "Caminho 3948",
    d: "M1939.757,928.679l3.134,17.869-1.491-1.279,13.084.971,1.189.088-.1,2.307-1.192-.016-13.12-.173a1.53,1.53,0,0,1-1.473-1.2l-.018-.083-3.936-17.709-.434-1.952,4.01-.8Z",
    transform: "translate(-1925.053 -902.798)",
    fill: "#efbc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3949",
    "data-name": "Caminho 3949",
    d: "M1918.736,929.509c-.31,4.277,2.456,15.387,6.818,19.208,2.59,2.269,11.215.745,11.215.745l.42-3.367s-6.452.972-7.926-2.778-2.405-13.988-4.586-15.55C1922.755,926.393,1918.875,927.588,1918.736,929.509Z",
    transform: "translate(-1910.208 -903.212)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3950",
    "data-name": "Caminho 3950",
    d: "M1877.207,912.494s2.377,2.225,4.871.875c0,0,.546,8.967,1.522,12.65s3.884,13.371,3.884,13.371l-17.79-.58C1869.484,930.633,1872.869,921.463,1877.207,912.494Z",
    transform: "translate(-1866.596 -890.154)",
    fill: "#dbc6af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3951",
    "data-name": "Caminho 3951",
    d: "M1867.893,905.6s-8.917,12.439-7.628,26.06c0,0-.817,2.64,8.842,2.592s10.255-1.363,10.255-1.363a93.052,93.052,0,0,1-5.776-25.652S1869.976,907.256,1867.893,905.6Z",
    transform: "translate(-1858.105 -884.025)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3952",
    "data-name": "Caminho 3952",
    d: "M1864.011,938.961c-1.3,2.037-2.572,4.167-3.745,6.3-.586,1.069-1.151,2.146-1.67,3.229a28.614,28.614,0,0,0-1.354,3.242c-.088.267-.161.521-.229.783l-.2.864c-.124.588-.244,1.178-.352,1.779-.217,1.2-.408,2.413-.585,3.632-.346,2.438-.644,4.9-.895,7.355l-.121,1.185-2.309-.16.053-1.19c.113-2.512.271-5,.482-7.509.109-1.253.234-2.507.389-3.768.076-.63.168-1.265.265-1.9l.169-.964c.069-.346.151-.693.241-1.022a31.667,31.667,0,0,1,1.325-3.72c.5-1.188,1.03-2.345,1.582-3.488,1.112-2.289,2.28-4.5,3.545-6.727l.989-1.739,3.5,2.138Z",
    transform: "translate(-1851.353 -910.295)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3953",
    "data-name": "Caminho 3953",
    d: "M1856.89,927.887c-3.2,2.857-5.261,9.575-6.813,15.162s-.871,14.205-.871,14.205l3.508.31s.585-8.715,2.135-12.433,8-11.723,7.521-14.362C1861.946,928.443,1858.327,926.6,1856.89,927.887Z",
    transform: "translate(-1848.248 -903.47)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3954",
    "data-name": "Caminho 3954",
    d: "M1842.867,1225.085c-.8-.2-1.378-2.1-1.034-4.512.318-2.22,1.5-3.515,2.32-3.383C1845.978,1217.485,1844.1,1225.389,1842.867,1225.085Z",
    transform: "translate(-1841.732 -1161.18)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3955",
    "data-name": "Caminho 3955",
    d: "M1867.553,1228.174c.356-.055.676-.988.6-2.228-.066-1.143-.544-1.866-.907-1.845C1866.438,1224.148,1867,1228.259,1867.553,1228.174Z",
    transform: "translate(-1864.069 -1167.336)",
    fill: "#f4caab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3956",
    "data-name": "Caminho 3956",
    d: "M2188.212,1476.163l-1.444-.257h0l-5.279-2.044v.043a1.254,1.254,0,0,1-1.161,1.075,2.414,2.414,0,0,1-1.552-.211.25.25,0,0,0-.119-.076c-.353,0-.638.577-.638,1.288a2.352,2.352,0,0,0,.085.641v.988h10.516v-1A.448.448,0,0,0,2188.212,1476.163Z",
    transform: "translate(-2140.868 -1389.505)",
    fill: "#1d646a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3957",
    "data-name": "Caminho 3957",
    d: "M2052.086,1424.684l-.98-1.091h0l-2.9-4.86-.027.033a1.253,1.253,0,0,1-1.576.133,2.414,2.414,0,0,1-1.093-1.122.249.249,0,0,0-.047-.133c-.278-.217-.858.062-1.3.622a2.368,2.368,0,0,0-.327.557l-.608.778,8.288,6.473.616-.788A.448.448,0,0,0,2052.086,1424.684Z",
    transform: "translate(-2020.969 -1339.432)",
    fill: "#1d646a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3958",
    "data-name": "Caminho 3958",
    d: "M2119.053,1098.386c-.1-.345-1.071-.535-2.29-.3-1.123.221-1.774.793-1.7,1.15C2115.215,1100.039,2119.211,1098.92,2119.053,1098.386Z",
    transform: "translate(-2084.858 -1055.151)",
    fill: "#efbc90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2001",
    "data-name": "Grupo 2001",
    transform: "translate(29.463 32.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3959",
    "data-name": "Caminho 3959",
    d: "M2122.858,1008.7h0a.806.806,0,0,0-1.012.525l-3.156,9.983h-9.461a.806.806,0,1,0,0,1.612h10.064a.806.806,0,0,0,.8-.7l3.292-10.414A.806.806,0,0,0,2122.858,1008.7Z",
    transform: "translate(-2108.423 -1008.661)",
    fill: "#1d646a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3960",
    "data-name": "Caminho 3960",
    d: "M2201.361,1025.088h.5l3.067-9.816h-.464Z",
    transform: "translate(-2191.094 -1014.541)",
    fill: "#f8aa6c"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon404.456edf45.svg";
export { ForwardRef as ReactComponent };